import { fetcher } from './core'

const search = {
  createSearch: (offer_request) =>
    fetcher('/offer_requests', {
      method: 'POST',
      api: process.env.REACT_APP_HOMER_API,
      body: { offer_request },
    }),
  getMultiOfferRecap: ({ offerRequestId, offers }) =>
    fetcher(`/offer_requests/${offerRequestId}/offers`, {
      method: 'POST',
      body: { offers },
    }),
}

export default search
